import React, { FC, useState } from 'react';
import './style.scss';

interface IDeliveryBranchSearchBoxResultProps {
  key: any;
  value: {
    main_text: string;
    secondary_text: string;
  };
  description: string;
  selectAddress: (address: string) => void;
}

export const DeliveryBranchSearchBoxResult: FC<IDeliveryBranchSearchBoxResultProps> = ({
  key,
  value,
  description,
  selectAddress,
}: IDeliveryBranchSearchBoxResultProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      key={key}
      onMouseEnter={() => setIsFocused(true)}
      onMouseLeave={() => setIsFocused(false)}
      onClick={() => selectAddress(description)}
      className={`branch-search-box-container ${isFocused && 'focused'}`}
    >
      <div className="branch-search-box-address-container">
        <div className="description text-truncate">
          {value.main_text} <div className="secondary-text text-truncate">{value.secondary_text}</div>
        </div>
      </div>
    </div>
  );
};
